import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuard } from './auth.guard';
import { HomeGuard } from './home.guard';
import { ExistingSessionGuard } from './existing-session.guard';

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [
    AuthGuard,
    HomeGuard,
    ExistingSessionGuard,
  ],
})
export class GuardsModule { }
